import { Heading, SuccessStoryCard, Button } from '../../../atoms';
import type { CustomerStory } from '../types';

export const CustomerStoryCard = ({ story }: { story: CustomerStory }) => (
  <SuccessStoryCard imgUrl={story.imgUrl} imgAlt={story.imgAlt}>
    <div className="payflow-ui-customer-stories-carousel__card-content">
      <Heading level="h4" className="payflow-ui-customer-stories-carousel__card-content_heading">
        {story.heading}
      </Heading>
      <p className="payflow-ui-customer-stories-carousel__card-content_paragraph">{story.description}</p>
      <Button
        variant="primary"
        size="medium"
        onClick={() => {
          window.open(story.ctaUrl, '_blank');
        }}
      >
        {story.ctaText}
      </Button>
    </div>
  </SuccessStoryCard>
);
